/**
 * Netto → Brutto mit MwSt aus globalen Country-Settings (Kalkulationsdaten).
 */

export function getCountryMwstSatz(settings: { country?: { MwSt_Satz?: number } } | null | undefined): number {
    const n = Number(settings?.country?.MwSt_Satz);
    if (Number.isFinite(n) && n >= 0) return n;
    return 19;
}

export function netToGross(net: number, mwstSatzPct: number): number {
    const netto = Number(net) || 0;
    const rate = Number(mwstSatzPct);
    const safeRate = Number.isFinite(rate) && rate >= 0 ? rate : 19;
    return Math.round(netto * (1 + safeRate / 100) * 100) / 100;
}

export function formatEuroDe(value: number): string {
    return (Number(value) || 0).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}
